/* angular:styles/component:css;7fb636fee359f2a72131e4cc0148e78e2d85985b1b2a9269ffe88fbb50b4aec4;C:\Users\medbi\source\repos\MBWeb7\src\app\shared\app-toasts\app-toasts-container.component.ts */
* {
  background-color: #FFE13C;
}
/*# sourceMappingURL=app-toasts-container.component.css.map */
